import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  private readonly http: HttpClient;

  constructor(private readonly backend: HttpBackend, private readonly httpClient: HttpClient) {
    /** Bypass Http Interceptors */
    this.http = new HttpClient(this.backend);
  }

  public fileUpload(file: File): Observable<any> {
    if (file) {
      const formData = new FormData();

      formData.append('avatar', file);

      formData.append('fileTitle', file.name);

      formData.append('fileType', 'request');

      return this.http.post('/api-file/file-upload.php', formData);
    }
    return of(null);
  }

  public getFile(url: string): Observable<any> {
    return this.httpClient.get(`/file${url}`, { responseType: 'arraybuffer' });
  }
}
